import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

export default function MentalCorporateTable() {
  let [promoCodes, setPromoCodes] = useState([]);

  const fetchPromo = async () => {
    const response = await fetch("https://api.thepsycure.com/all-servey");
    const promos = await response.json();

    if (response.ok) {
      setPromoCodes(promos);
    }
  };

  useEffect(() => {
    fetchPromo();
  }, []);

  const columns = [
    { id: "firstName", label: "First Name", minWidth: 170, align: "center" },
    { id: "lastName", label: "Last Name", minWidth: 150, align: "center" },
    {
      id: "businessEmail",
      label: "Business Email",
      minWidth: 150,
      align: "center",
    },
    {
      id: "contactNumber",
      label: "Contact Number",
      minWidth: 170,
      align: "center",
    },
    {
      id: "companyName",
      label: "Company Name",
      minWidth: 150,
      align: "center",
    },
    {
      id: "companySize",
      label: "Company Size",
      minWidth: 150,
      align: "center",
    },
    {
      id: "companyBased",
      label: "Company Based",
      minWidth: 150,
      align: "center",
    },
    { id: "interested", label: "Interested", minWidth: 150, align: "center" },
    {
      id: "howToSupport",
      label: "How To Support",
      minWidth: 150,
      align: "center",
    },
  ];

  function createData(
    id,
    firstName,
    lastName,
    businessEmail,
    contactNumber,
    companyName,
    companySize,
    companyBased,
    interested,
    howToSupport
  ) {
    return {
      id,
      firstName,
      lastName,
      businessEmail,
      contactNumber,
      companyName,
      companySize,
      companyBased,
      interested,
      howToSupport,
    };
  }

  const rows = [];
  promoCodes.forEach((promo) =>
    rows.push(
      createData(
        promo?._id,
        promo?.firstName,
        promo?.lastName,
        promo?.businessEmail,
        promo?.contactNumber,
        promo?.companyName,
        promo?.companySize,
        promo?.companyBased,
        promo?.interested,
        promo?.howToSupport
      )
    )
  );

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div
      style={{
        boxShadow: "0px 24px 48px rgba(0, 0, 0, 0.25)",
        padding: "2rem",
        borderRadius: ".8rem",
        marginTop: "4rem",
      }}
    >
      <h2 style={{ textAlign: "center" }}>Mental Corporate servey</h2>
      <TableContainer className="table-container" sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, fontWeight: 600 }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
}
